import { render, staticRenderFns } from "./ButtonToggle.vue?vue&type=template&id=5d049ad5&"
import script from "./ButtonToggle.vue?vue&type=script&lang=js&"
export * from "./ButtonToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports